import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import useFrasesHero from '@/components/hooks/useFrasesHero';

const INTERVALO_MS = 6000;

const HeroRotatingTitle = () => {
  const { t } = useTranslation();
  const { frases } = useFrasesHero();
  const [index, setIndex] = useState(0);

  const textos =
    frases.length > 0 ? frases.map((f) => f.frase) : [t('login.heroTitle')];

  useEffect(() => {
    if (textos.length <= 1) return;
    const id = setInterval(
      () => setIndex((i) => (i + 1) % textos.length),
      INTERVALO_MS
    );
    return () => clearInterval(id);
  }, [textos.length]);

  const actual = textos[index % textos.length];

  return (
    <div className="relative z-10 max-w-4xl min-h-[2.5em] flex items-center justify-center">
      <AnimatePresence mode="wait">
        <motion.h1
          key={actual}
          className="text-2xl sm:text-5xl font-semibold tracking-tight text-white leading-tight drop-shadow-md"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 1, ease: 'easeInOut' }}
        >
          {actual}
        </motion.h1>
      </AnimatePresence>
    </div>
  );
};

export default HeroRotatingTitle;